// import React, { useEffect, useState } from 'react'
// import CountUp from 'react-countup';
// import axios from 'axios';
// import Atropos from 'atropos/react';
// import { useLocation } from 'react-router-dom/cjs/react-router-dom';
// import { apiRequest } from '../../apiServices/allApi'
// import ReactPaginate from 'react-paginate'
// import { Link } from 'react-router-dom'
// // import "../../";

// export default function AgentHistory() {

//     const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//     const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
//     const nodeMode = process.env.NODE_ENV;
//     if (nodeMode === "development") {
//       var baseUrl = beckendLocalApiUrl;
//     } else {
//       baseUrl = beckendLiveApiUrl;
//     }
//     const path = localStorage.getItem("id");
//   const [numberOfPages, setNumberOfPages] = useState(0)
//     const [pageNumber, setPageNumber] = useState(0)
//       const [searchType, setSearchType] = useState("Phone")
//         const [searchList, setSearchList] = useState(0)
      

//           //   searching handler
//   const searchHandler = event => {
//     let key = event.target.value
//     setSearchList(key)
//   }
    
//  const id = localStorage.getItem('id')

  
//    const handlePageClick = async data => {
//     let currentPage = data.selected + 1
//     setPageNumber(currentPage)
//     // scroll to the top
//     //window.scrollTo(0, 0)
//   }

//   const [Agent, setAgent] = useState([])
//   const [AgentToday, setAgentToday] = useState("")
//   const [startDate, setStartDate] = useState(new Date());
//   const [endDate, setEndDate] = useState(new Date());

//     const admin =async (s,e) => {
//         const access_token = localStorage.getItem("token")
//         const headers = {
//           Authorization: `Bearer ${access_token}`
//         }
       
//           try {
//                             const res = await apiRequest(`admin/agent/withdraw/history/${path}?&_q=${searchList}&_stype=${searchType}&_startingfrom=`+s+ "&endto="+e,"GET", null,headers)
//                            if (res.data) {
//                                         setAgent(res.data?.data)
//       setNumberOfPages(res.data.totalPages)
//       setAgentToday(res.data?.todayWithdrawAmount)

//                            }
//                               } catch (e) {
//                                 // setLoading(false)
                                  
//                               }
//                               finally {
//                               }
//       }

//       function filterData() {
//         admin(new Date(startDate), new Date(endDate));
//       }
    
//       function daterange(s, e) {
//         if (s > e) {
//           alert("Starting date is greater than ending date");
//         } else {
//           setStartDate(s);
//           setEndDate(e);
//         }
//       console.log(s,e)
//         // Change start date format
//         var startDate = new Date(s);
//         var startDay = startDate.getDate();
//         var startMonth = startDate.getMonth() + 1; // Months are zero-based
//         var startYear = startDate.getFullYear();
//         var startHours = startDate.getHours();
//         var startMinutes = startDate.getMinutes();
//         var startSeconds = startDate.getSeconds();
      
//         // Change end date format
//         var endDate = new Date(e);
//         var endDay = endDate.getDate();
//         var endMonth = endDate.getMonth() + 1; // Months are zero-based
//         var endYear = endDate.getFullYear();
//         var endHours = endDate.getHours();
//         var endMinutes = endDate.getMinutes();
//         var endSeconds = endDate.getSeconds();
      
      
//       }
//    const dateFormat = e => {
//     const date = new Date(e)
//     const newDate = date.toLocaleString('default', {
//       month: 'long',
//       day: 'numeric',
//       hour: 'numeric',
//       hour12: true,
//       minute: 'numeric'
//     })
//     return newDate
//   }

//       useEffect(() => {
//         admin(new Date(new Date().setHours(0,0,0,0)), new Date());
//       },[searchList, searchType])


//     return (
//           <div className='row mt-5'>
//         <div className='col-12 grid-margin'>
//           <div className='card'>
           
//             <div className='card-body text-light table_bg'>
//                 <span>
//               <h4 className=' dashboard_heading mb-2' >My withdrawal History</h4>
//               <h4 className=' dashboard_heading'>Withdraw = {AgentToday}</h4>
//                 </span>

//                   <div className='row'>
//                      <select
//                   className='form-control col-sm-3 m-2'
//                   id='searchType'
//                   name='searchtype'
//                   onChange={e => setSearchType(e.target.value)}
//                 >
//                                       <option value='Phone'>Phone</option>

//                   {/* <option value='Name'>Name</option> */}
//                   {/* <option value='Phone'>Phone</option> */}
//                   <option value='account_number'>Ac No.</option>
//                   <option value='upiId'>Upi Id</option>
//                   <option value='amount'>Amount</option>
//                 </select>
//                 <input
//                   type='text'
//                   placeholder='Search...'
//                   className='form-control col-sm-4 m-2'
//                   onChange={searchHandler}
//                 />
//             <div className="form-group mx-sm-3 mb-2 col-lg-4 col-sm-12">
//               <label htmlFor="startDate" className="sr-only">
//                 Start Date
//               </label>
//               <input type="datetime-local" id="" name="" className="form-control" value={startDate}   onChange={(e) => daterange(e.target.value, endDate)}></input>
              
//             </div>
//             <h5 className='text-dark'>To</h5>
//             <div className="form-group mx-sm-3 mb-2 col-lg-4 col-sm-12">
//               <label htmlFor="endDate" className="sr-only">
//                 End Date
//               </label>
//               <input type="datetime-local" id="" name="" className="form-control" value={endDate} onChange={(e) => daterange(startDate,e.target.value)}></input>
           
//             </div>
//             <button className="btn btn-success" onClick={filterData}>Submit</button>
//           </div>
//               <div className='table-responsive'>

//                 <table className='table text-light'>
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                          {
//                           id =="6931311e30989ed52eebce14" ?
//                       <th> ID</th> : ""}
//                       <th> Phone</th>
//                       <th> User</th>
//                       <th>UPI ID</th>
//                       <th>Account Number</th>
//                       <th> Amount </th>
//                       <th> Status </th>
//                       <th> Reason </th>
//                       <th> Time </th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {Agent &&
//                       Agent?.map((data, key) => {
//                         let currentTime = Date.now()
//                         let gameCreatedAt = new Date(data.createdAt).getTime()
//                         return (
//                           <tr>
//                             <td>{key + 1}</td>
//                                {
//                           id =="6931311e30989ed52eebce14" ?
//                             <td>{data._id}</td> : ""}
//                             <td>
                            
//                                 <span className='pl-2'>
//                                   {data.User_id ? data.User_id.Phone : ''}
//                                 </span>
                            
//                             </td>
//                             <td>
//                               {data.User_id && (
//                                 <Link
//                                   className='btn btn-sm btn-outline-info'
//                                   to={`/user/view_user/${data.User_id._id}`}
//                                 >
//                                   {data.User_id.Name}
//                                 </Link>
//                               )}
//                             </td>
                           
//                             <td>
//                               <span className='pl-2'>
//                                 {data?.upiId??"----"}
//                               </span>
//                             </td>
//                              <td>
//                               <span className='pl-2'>{data.account_number??"----"}</span>
//                             </td>
                            
//                             <td>{data.amount}</td>
//                             <td className='font-weight-bold text-success'>
//                               {data.status === 'none'
//                                 ? 'Proccessing'
//                                 : data.status}
//                             </td>
//                              <td>
                            
//                                 <span className='pl-2'>
//                                   {data.txn_msg}
//                                 </span>
                            
//                             </td>
                          
//                             <td>{dateFormat(data.createdAt).split(',')[0]}</td>
//                           </tr>
//                         )
//                       })}
//                   </tbody>
//                 </table>
//               </div>

//               <div className='mt-4'>
//                 <ReactPaginate
//                   previousLabel={'Previous'}
//                   nextLabel={'Next'}
//                   breakLabel={'...'}
//                   pageCount={numberOfPages}
//                   marginPagesDisplayed={2}
//                   pageRangeDisplayed={3}
//                   onPageChange={handlePageClick}
//                   containerClassName={'pagination justify-content-center'}
//                   pageClassName={'page-item'}
//                   pageLinkClassName={'page-link'}
//                   previousClassName={'page-item'}
//                   previousLinkClassName={'page-link'}
//                   nextClassName={'page-item'}
//                   nextLinkClassName={'page-link'}
//                   breakClassName={'page-item'}
//                   breakLinkClassName={'page-link'}
//                   activeClassName={'active'}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     )
// }


import React, { useEffect, useState } from 'react'
import CountUp from 'react-countup';
import axios from 'axios';
import Atropos from 'atropos/react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { apiRequest } from '../../apiServices/allApi'
import ReactPaginate from 'react-paginate'
import { Link } from 'react-router-dom'
// import './AgentHistory.css'

export default function AgentHistory() {

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  const path = localStorage.getItem("id");
  const [numberOfPages, setNumberOfPages] = useState(0)
  const [pageNumber, setPageNumber] = useState(0)
  const [searchType, setSearchType] = useState("Phone")
  const [searchList, setSearchList] = useState(0)

  const searchHandler = event => {
    let key = event.target.value
    setSearchList(key)
  }

  const id = localStorage.getItem('id')

  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
  }

  const [Agent, setAgent] = useState([])
  const [AgentToday, setAgentToday] = useState("")
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const admin = async (s, e) => {
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    try {
      const res = await apiRequest(`admin/agent/withdraw/history/${path}?&_q=${searchList}&_stype=${searchType}&_startingfrom=` + s + "&endto=" + e, "GET", null, headers)
      if (res.data) {
        setAgent(res.data?.data)
        setNumberOfPages(res.data.totalPages)
        setAgentToday(res.data?.todayWithdrawAmount)
      }
    } catch (e) {
    }
  }

  function filterData() {
    admin(new Date(startDate), new Date(endDate));
  }

  function daterange(s, e) {
    if (s > e) {
      alert("Starting date is greater than ending date");
    } else {
      setStartDate(s);
      setEndDate(e);
    }
    console.log(s, e)
    
    var startDate = new Date(s);
    var startDay = startDate.getDate();
    var startMonth = startDate.getMonth() + 1;
    var startYear = startDate.getFullYear();
    var startHours = startDate.getHours();
    var startMinutes = startDate.getMinutes();
    var startSeconds = startDate.getSeconds();

    var endDate = new Date(e);
    var endDay = endDate.getDate();
    var endMonth = endDate.getMonth() + 1;
    var endYear = endDate.getFullYear();
    var endHours = endDate.getHours();
    var endMinutes = endDate.getMinutes();
    var endSeconds = endDate.getSeconds();
  }

  const dateFormat = e => {
    const date = new Date(e)
    const newDate = date.toLocaleString('default', {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      hour12: true,
      minute: 'numeric'
    })
    return newDate
  }

  useEffect(() => {
    admin(new Date(new Date().setHours(0, 0, 0, 0)), new Date());
  }, [searchList, searchType])

  const getStatusClass = (status) => {
    if (status === 'SUCCESS' || status === 'PAID') return 'status-success';
    if (status === 'FAILED' || status === 'reject') return 'status-failed';
    if (status === 'none') return 'status-processing';
    return 'status-pending';
  }

  return (
    <div className='agenthistory-page-container'>
      <div className='agenthistory-main-card'>
        
        {/* Header & Today Summary Badge */}
        <div className='agenthistory-header-flex'>
          <h4 className='agenthistory-heading-main'>My Withdrawal History</h4>
          <div className='today-withdraw-badge'>
            Total Withdraw: ₹{AgentToday || 0}
          </div>
        </div>

        {/* Date Filter & Search Panel */}
        <div className='agenthistory-filter-panel'>
          <select
            className='custom-agenthistory-input'
            id='searchType'
            name='searchtype'
            style={{ maxWidth: '180px' }}
            onChange={e => setSearchType(e.target.value)}
          >
            <option value='Phone'>Phone</option>
            <option value='account_number'>Account No.</option>
            <option value='upiId'>UPI ID</option>
            <option value='amount'>Amount</option>
          </select>

          <input
            type='text'
            placeholder='Search Keyword...'
            className='custom-agenthistory-input'
            style={{ flex: 1, minWidth: '180px' }}
            onChange={searchHandler}
          />

          <div className='date-group'>
            <label htmlFor='startDate'>Start Date</label>
            <input
              type='datetime-local'
              id='startDate'
              className='custom-agenthistory-input'
              value={startDate}
              onChange={(e) => daterange(e.target.value, endDate)}
            />
          </div>

          <span className='date-separator-text'>To</span>

          <div className='date-group'>
            <label htmlFor='endDate'>End Date</label>
            <input
              type='datetime-local'
              id='endDate'
              className='custom-agenthistory-input'
              value={endDate}
              onChange={(e) => daterange(startDate, e.target.value)}
            />
          </div>

          <button className='btn-filter-submit' onClick={filterData}>
            Submit
          </button>
        </div>

        {/* Table Content */}
        <div className='table-responsive-wrapper'>
          <table className='agenthistory-modern-table'>
            <thead>
              <tr>
                <th>#</th>
                {id == "6931311e30989ed52eebce14" && <th>ID</th>}
                <th>Phone</th>
                <th>User</th>
                <th>UPI ID</th>
                <th>Account Number</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Reason</th>
                <th>Time</th>
              </tr>
            </thead>

            <tbody>
              {Agent &&
                Agent?.map((data, key) => {
                  return (
                    <tr key={data?._id || key}>
                      <td>{key + 1}</td>

                      {id == "6931311e30989ed52eebce14" && (
                        <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{data?._id}</td>
                      )}

                      <td style={{ color: '#34d399', fontWeight: 600 }}>
                        {data.User_id ? data.User_id.Phone : ''}
                      </td>

                      <td>
                        {data.User_id && (
                          <Link
                            className='user-link-item'
                            to={`/user/view_user/${data.User_id._id}`}
                          >
                            <span className={data.User_id?.Red_zone == true ? "text-danger" : ""}>
                              {data.User_id.Name}
                            </span>
                          </Link>
                        )}
                      </td>

                      <td style={{ fontFamily: 'monospace', color: '#38bdf8' }}>
                        {data?.upiId ?? "----"}
                      </td>

                      <td style={{ fontFamily: 'monospace', color: '#cbd5e1' }}>
                        {data.account_number ?? "----"}
                      </td>

                      <td>
                        <span className='amount-text-orange'>₹{data.amount}</span>
                      </td>

                      <td className={`status-badge-text ${getStatusClass(data.status)}`}>
                        {data.status === 'none' ? 'Processing' : data.status}
                      </td>

                      <td style={{ color: '#94a3b8' }}>
                        {data.txn_msg ?? "----"}
                      </td>

                      <td>{dateFormat(data.createdAt).split(',')[0]}</td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </div>

        {/* Pagination Container */}
        <div className='pagination-container'>
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageCount={numberOfPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={'pagination justify-content-center'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}
          />
        </div>

      </div>
    </div>
  )
}
